
import AdminPage from './containers/admin-page';
import AdsPage from './containers/ads-page';
import BannersPage from './containers/banners-page';
import BrandPage from './containers/brand-page';
import BugsPage from './containers/bugs-page';
import BugEditorPage from './containers/bug-editor-page'
import CategoryPage from './containers/category-page';
import CategoryFeaturePage from './containers/category-feature-page'
import CreditNotePage from './containers/credit-note-page'
import CreditOverviewPage from './containers/credit-overview-page'
import CreditOverviewProfilePage from './containers/credit-overview-profile-page'
import CreditPaymentPage from './containers/credit-payment-page.js'
import CreditPaymentProfilePage from './containers/credit-payment-profile-page.js'
import CreditApprovalPage from './containers/credit-approval-page.js'
import CustomerJourneyPage from './containers/customer-journey-page';
import DataPage from './containers/data-page';
import DataReportPage from './containers/data-report-page';
import DataReportEditorPage from './containers/data-report-editor-page';
import DataReportHistoryPage from './containers/data-report-history-page';
import DeliveriesPage from './containers/deliveries-page.js';
import DeliveryPage from './containers/delivery-page'
import DeliveryRoutes from './containers/delivery-routes'
import DocsPage from './containers/docs-page'
// import DocsEditorPage from './containers/docs-editor-page'
import EmailPage from './containers/email-page';
import EezeeAdsPage from './containers/eezee-ads-page'
import EezeeAdsProfilePage from './containers/eezee-ads-profile-page'
import FocusOrderPage from './containers/focus-order-page';
import EnquiryPage from './containers/enquiry-page';
import EnterprisePage from './containers/enterprise-page'
import EnterpriseContractPage from './containers/enterprise-contract-page';
import TermContractsPage from './containers/term-contracts-page';
import SupplierPriceListsPage from './containers/supplier-price-lists-page';
import EnterpriseSalesAgentOverviewPage from './containers/enterprise-sales-agent-page';
import EnterpriseProfilePage from './containers/enterprise-profile-page'
import EnterpriseRtbPage from './containers/enterprise-rtb';
import FeaturedPage from './containers/featured-page';
import FinanceSOAPage from './containers/finance-soa-page';
import FinanceRefundsPage from './containers/finance-refund-page'
import FinanceNotificationPage from './containers/finance-notifications-page';
import IotDevicesPage from "./containers/iot-devices-page";
import IotLockerManagerPage from "./containers/iot-locker-manager";
import LeafPagePage from './containers/leaf-page-page';
import MassDuplicateProductsPage from './containers/mass-duplicate-products-page.js';
import HomePage from "./containers/home-page";
import OptimizedRoute from './containers/optimizedRoute'
import OrdersPageV3 from './containers/order-page-v3'
import PaymentAdvicePage from './containers/finance-payment-advice-page';
import ProductPage from './containers/product-page';
import ProductExStockPage from './containers/product-ex-stock-page';
import ProductExStockTablePage from './containers/product-ex-stock-table-page';
import ProductChangesPage from './containers/product-changes'
import ProductSynonymsPage from './containers/product-synonyms'
import PromoPage from './containers/promo-page';
import QuotationPage from './containers/quotation-page';
import RfidTagProductPage from "./containers/rfid-tag-product";
import SlaDiscrepanciesPage from './containers/sla-discrepancies-page';
import newSlaDiscrepanciesPage from './containers/new-sla-discrepancies-page';
import StockIntegrationsPage from './containers/stock-integrations-page';
import SupplierPage from './containers/supplier-page';
import SupplierProfilePage from './containers/supplier-profile-page';
import ThreePsEditorPage from './containers/three-ps-editor-page';
import TransferProductsPage from './containers/mass-transfer-products-page';
import UserPage from './containers/user-page';
import UserManagementPage from './containers/user-management-page';
import VerificationPage from './containers/verification-page';
import VmPage from './containers/vm-page'
import VmSupplierPage from './containers/vm-supplier-page'

export const routes = [{
    path: "/",
    component: HomePage
}, {
    path: '/ads',
    component: AdsPage
}, {
    path: '/admins',
    component: AdminPage
}, {
    path: '/brands',
    component: BrandPage
}, {
    path: '/bugs',
    component: BugsPage
}, {
    path: '/bugs/new',
    component: BugEditorPage
}, {
    path: '/bugs/:bugId',
    component: BugEditorPage
}, {
    path: '/category',
    component: CategoryPage
}, {
    path: '/category-feature',
    component: CategoryFeaturePage
}, {
    path: '/category-feature/:categoryFeatureId',
    component: CategoryFeaturePage
}, {
    path: '/finance/credit-note',
    component: CreditNotePage
}, {
    path: '/credit-overview',
    component: CreditOverviewPage
}, {
    path: '/credit-overview/:entityType/:entityId',
    component: CreditOverviewProfilePage
}, {
    path: '/credit-payment',
    component: CreditPaymentPage
}, {
    path: '/credit-payment/:paymentId',
    component: CreditPaymentProfilePage
}, {
    path: '/credit-approval',
    component: CreditApprovalPage
}, {
    path: '/data-reports',
    component: DataReportPage
}, {
    path: '/data-reports/new',
    component: DataReportEditorPage
}, {
    path: '/data-reports/:dataReportId',
    component: DataReportEditorPage
}, {
    path: '/data-reports-history',
    component: DataReportHistoryPage
}, {
    path: '/delivery/scheduler',
    component: DeliveryPage
}, {
    path: '/delivery/routes',
    component: DeliveryRoutes
}, {
    path: '/delivery/routes/:id',
    component: OptimizedRoute
}, {
    path: '/deliveries',
    component: DeliveriesPage
}, {
    path: '/docs/:activeTab?/:docId?',
    component: DocsPage
}, {
    path: '/email',
    component: EmailPage
}, {
    path: '/enquiry',
    component: EnquiryPage
}, {
    path: '/enterprise/dashboard',
    component: EnterprisePage
}, {
    path: '/enterprise/contracts',
    component: EnterpriseContractPage
}, {
    path: '/enterprise/contracts/:customerId',
    component: EnterpriseContractPage
}, {
    // before /enterprise/:enterpriseId, which would otherwise match
    path: '/enterprise/term-contracts',
    component: TermContractsPage
}, {
    path: '/enterprise/term-contracts/:termContractId',
    component: TermContractsPage
}, {
    path: '/enterprise-rtb',
    component: EnterpriseRtbPage
}, {
    path: '/enterprise-sales-agent',
    component: EnterpriseSalesAgentOverviewPage
}, {
    path: '/enterprise/:enterpriseId',
    component: EnterpriseProfilePage
}, {
    path: '/enterprise/:enterpriseId/:pageKey',
    component: EnterpriseProfilePage
}, {
    path: '/eezee-ads',
    component: EezeeAdsPage
}, {
    path: '/eezee-ads/:adId',
    component: EezeeAdsProfilePage
}, {
    path: '/finance/supplier-soa',
    component: FinanceSOAPage
}, {
    path: '/finance/refunds/:searchParam?',
    component: FinanceRefundsPage
}, {
    path: '/finance/payment-advice',
    component: PaymentAdvicePage
}, {
    path: '/finance/notifications',
    component: FinanceNotificationPage
}, {
    path: '/homepage/banners',
    component: BannersPage
}, {
    path: '/homepage/featured',
    component: FeaturedPage
}, {
    path: '/iot-devices',
    component: IotDevicesPage
}, {
    path: '/iot-devices/locker/:lockerDeviceName',
    component: IotLockerManagerPage
}, {
    path: "/orders",
    component: OrdersPageV3
}, {
    path: "/orders/:orderId",
    component: OrdersPageV3
}, {
    path: "/products/dashboard",
    component: ProductPage
}, {
    path: "/products/ex-stock",
    component: ProductExStockPage
}, {
    path: "/products/ex-stock/all",
    component: ProductExStockTablePage
}, {
    path: "/products/transfer",
    component: TransferProductsPage
}, {
    path: "/products/mass-duplicate",
    component: MassDuplicateProductsPage
}, {
    path: "/products/synonyms",
    component: ProductSynonymsPage
}, {
    path: "/products/changes",
    component: ProductChangesPage
}, {
    path: "/promo",
    component: PromoPage
}, {
    path: "/quotation",
    component: QuotationPage
}, {
    path: "/quotation/:quotationId",
    component: QuotationPage
}, {
    path: "/rfid-tag-product",
    component: RfidTagProductPage
}, {
    path: "/tech/stock-integration",
    component: StockIntegrationsPage
}, {
    path: "/tech/stock-integration/:supplierId",
    component: StockIntegrationsPage
}, {
    path: "/sla",
    component: SlaDiscrepanciesPage
}, {
    path: "/sla/new",
    component: newSlaDiscrepanciesPage
}, {
    path: "/sla/:slaId",
    component: newSlaDiscrepanciesPage
}, {
    // before /supplier/:supplierId, which would otherwise match
    path: "/supplier/price-lists",
    component: SupplierPriceListsPage
}, {
    path: "/supplier/price-lists/:priceListId",
    component: SupplierPriceListsPage
}, {
    path: "/supplier",
    component: SupplierPage
}, {
    path: "/supplier/add",
    component: SupplierPage
}, {
    path: "/supplier/:supplierId",
    component: SupplierProfilePage
}, {
    path: "/three-ps/editor",
    component: ThreePsEditorPage
}, {
    path: "/users",
    component: UserPage
}, {
    path: "/users/:page",
    component: UserPage
}, {
    path: "/user/:userId",
    component: UserManagementPage
}, {
    path: "/verification/:param?",
    component: VerificationPage
}, {
    path: "/customerjourney/:cartId",
    component: CustomerJourneyPage
}, {
    path: "/focus-order/:orderId",
    component: FocusOrderPage
}, {
    path: "/leaf-pages",
    component: LeafPagePage
}, {
    path: '/data',
    component: DataPage
}, {
    path: '/vm-supplier',
    component: VmSupplierPage
}, {
    path: '/vm',
    component: VmPage
}]




// WEBPACK FOOTER //
// ./src/routes.js